/* Desktop disclosures and mobile screens inside the existing theme drawer. */
(() => {
  if (window.parkMenuInstalled) return;
  window.parkMenuInstalled = true;
  const desktop = '.park-menu--desktop';
  const closeTimers = new WeakMap();
  const syncSubmenu = () => {
    const header = document.getElementById('pageheader');
    if (!header) return;
    const panel = header.querySelector(`${desktop} .park-menu__panel:not([hidden])`);
    const height = window.innerWidth >= 1280 && panel ? Math.ceil(panel.querySelector('.park-menu__native-groups')?.getBoundingClientRect().height || panel.getBoundingClientRect().height) : 0;
    header.style.setProperty('--park-submenu-height', height + 'px');
    const section = header.closest('.section-header');
    if (section) {
      const total = Math.ceil(section.getBoundingClientRect().height) + 'px';
      document.documentElement.style.setProperty('--theme-header-height', total);
      if (getComputedStyle(section).position === 'sticky') document.documentElement.style.setProperty('--theme-sticky-header-height', total);
    }
  };

  const itemFor = target => target.closest(`${desktop} > .park-menu__item`);
  const controls = item => item?.querySelector(':scope > .park-menu__toggle');
  const clearCategories = item => {
    item.querySelectorAll('[data-menu-category]').forEach(button => button.setAttribute('aria-expanded', 'false'));
    item.querySelectorAll('[data-menu-children]').forEach(panel => { panel.hidden = true; });
  };
  const openCategory = button => {
    const item = itemFor(button);
    if (!item || controls(item)?.getAttribute('aria-expanded') !== 'true') return;
    if (button.getAttribute('aria-expanded') === 'true') return;
    clearCategories(item);
    const panel = document.getElementById(button.dataset.menuCategory);
    if (!panel || !item.contains(panel)) return;
    button.setAttribute('aria-expanded', 'true');
    panel.hidden = false;
    syncSubmenu();
    document.dispatchEvent(new CustomEvent('park:menu-panel-open', { detail: { panel } }));
  };
  const selectCategory = event => {
    const button = event.target.closest('[data-menu-category]');
    if (button) openCategory(button);
    else if (event.target.closest('[data-menu-category-leaf]')) {
      const item = itemFor(event.target);
      if (item) { clearCategories(item); syncSubmenu(); }
    }
  };
  document.addEventListener('pointerover', event => {
    if (event.pointerType !== 'touch') selectCategory(event);
  });
  document.addEventListener('focusin', selectCategory);
  const close = (item, sync = true) => {
    clearTimeout(closeTimers.get(item));
    const button = controls(item);
    const panel = item.querySelector(':scope > .park-menu__panel');
    if (!button || !panel || (button.getAttribute('aria-expanded') !== 'true' && panel.hidden)) return false;
    clearCategories(item);
    button.setAttribute('aria-expanded', 'false');
    panel.hidden = true;
    if (sync) syncSubmenu();
    return true;
  };
  const closeAll = (except, sync = true) => {
    let changed = false;
    document.querySelectorAll(`${desktop} > .park-menu__item`).forEach(item => {
      if (item !== except && close(item, false)) changed = true;
    });
    if (changed && sync) syncSubmenu();
    return changed;
  };
  const open = item => {
    clearTimeout(closeTimers.get(item));
    const button = controls(item);
    if (!button) return;
    closeAll(item, false);
    button.setAttribute('aria-expanded', 'true');
    item.querySelector(':scope > .park-menu__panel').hidden = false;
    syncSubmenu();
  };
  document.addEventListener('click', event => {
    if (window.innerWidth < 1280) return;
    const button = event.target.closest(`${desktop} .park-menu__toggle`);
    const category = event.target.closest('[data-menu-category]');
    if (category) { category.focus({ preventScroll: true }); openCategory(category); return; }
    if (button) {
      // Safari pointer clicks do not focus buttons; Escape must reach this menu.
      button.focus();
      const item = itemFor(button);
      button.getAttribute('aria-expanded') === 'true' ? close(item) : open(item);
    } else if (event.target.closest(`${desktop} .park-menu__panel a`) || !event.target.closest(desktop)) closeAll();
  });
  document.addEventListener('focusout', event => {
    const item = itemFor(event.target);
    // Safari emits focusout(null) on pointer-down before the destination click.
    // Keep its target mounted; outside clicks and actual focus transfers close it.
    if (item && event.relatedTarget && !item.contains(event.relatedTarget)) close(item);
  });
  document.addEventListener('keydown', event => {
    const item = itemFor(event.target);
    if (!item || !controls(item)) return;
    // Panels live after the category row in the DOM. Keep keyboard traversal in
    // reading order: category, its links, next category (and the reverse).
    if (event.key === 'Tab' && controls(item).getAttribute('aria-expanded') === 'true') {
      const order = [{ element: controls(item) }];
      const parentLink = item.querySelector('.park-menu__parent-link');
      if (parentLink?.getClientRects().length) order.push({ element: parentLink });
      item.querySelectorAll('.park-menu__category .park-menu__icon-link').forEach(category => {
        order.push({ element: category, category });
        const panel = category.dataset.menuCategory && document.getElementById(category.dataset.menuCategory);
        if (panel && item.contains(panel)) {
          panel.querySelectorAll('a[href]').forEach(element => order.push({ element, category }));
        }
      });
      const index = order.findIndex(entry => entry.element === event.target);
      const next = index >= 0 ? order[index + (event.shiftKey ? -1 : 1)] : null;
      if (next) {
        event.preventDefault();
        if (next.category?.dataset.menuCategory) openCategory(next.category);
        else { clearCategories(item); syncSubmenu(); }
        next.element.focus();
        return;
      }
      // At the outer boundaries native Tab leaves the menu normally.
    }
    const activeCategory = item.querySelector('[data-menu-category][aria-expanded="true"]');
    if (event.key === 'Escape' && activeCategory) {
      event.preventDefault(); clearCategories(item); activeCategory.focus(); clearCategories(item); syncSubmenu(); return;
    }
    if (event.key === 'ArrowDown' && event.target.closest('[data-menu-category]')) {
      event.preventDefault(); openCategory(event.target.closest('[data-menu-category]'));
      item.querySelector('[data-menu-children]:not([hidden]) a')?.focus(); return;
    }
    if (event.key === 'Escape' && controls(item).getAttribute('aria-expanded') === 'true') {
      event.preventDefault(); close(item); controls(item).focus();
    } else if (event.key === 'ArrowDown' && event.target.closest('.park-menu__top-link, .park-menu__toggle')) {
      event.preventDefault(); open(item); item.querySelector('.park-menu__category .park-menu__icon-link')?.focus();
    }
  });
  window.addEventListener('resize', () => {
    if (window.innerWidth < 1280) closeAll();
    else if (document.body.classList.contains('reveal-mobile-nav')) window.theme?.closeMobileNav?.();
  });
  window.addEventListener('pageshow', () => closeAll());


  // Collapse only on desktop. The header only turns compact once the height it loses is scrolled past,
  // so the flow spacer that keeps the document height always sits hidden under the header (no white gap).
  let scrollFrame = 0;
  let collapseDelta = null;
  const measureCollapse = (header, section) => {
    if (!section || header.classList.contains('park-header--compact')) return collapseDelta;
    const full = section.getBoundingClientRect().height;
    header.classList.add('park-header--compact');
    const compactHeight = section.getBoundingClientRect().height;
    header.classList.remove('park-header--compact');
    collapseDelta = Math.max(0, Math.round(full - compactHeight));
    return collapseDelta;
  };
  const syncHeader = () => {
    scrollFrame = 0;
    const header = document.getElementById('pageheader');
    if (!header) return;
    const wasCompact = header.classList.contains('park-header--compact');
    const announcement = document.querySelector('.section-announcement-bar');
    const stickyStart = announcement ? announcement.offsetTop + announcement.clientHeight : 0;
    const delta = collapseDelta ?? measureCollapse(header, header.closest('.section-header')) ?? 0;
    const threshold = Math.max(8, stickyStart + delta);
    const compact = window.innerWidth >= 1280 && (wasCompact ? window.scrollY > threshold - 4 : window.scrollY > threshold);
    if (compact === wasCompact) return;
    if (compact && header.querySelector('park-mobile-search')?.contains(document.activeElement)) {
      header.querySelector('.park-menu__top-link')?.focus({ preventScroll: true });
    }
    const scrollBefore = window.scrollY;
    const section = header.closest('.section-header');
    const beforeHeight = section?.getBoundingClientRect().height || 0;
    let spacer = section?.nextElementSibling;
    if (section && !spacer?.classList.contains('park-header-flow-spacer')) {
      spacer = document.createElement('div');
      spacer.className = 'park-header-flow-spacer';
      spacer.setAttribute('aria-hidden', 'true');
      section.after(spacer);
    }
    header.classList.toggle('park-header--compact', compact);
    if (section && spacer) {
      // Preserve document height so scroll anchoring cannot undo the transition.
      spacer.style.height = compact ? Math.max(0, beforeHeight - section.getBoundingClientRect().height) + 'px' : '0px';
    }
    // Layout measurements can apply browser scroll anchoring before the spacer is sized.
    if (window.scrollY !== scrollBefore) window.scrollTo({ top: scrollBefore, behavior: 'instant' });
    if (section) {
      const height = Math.ceil(section.getBoundingClientRect().height) + 'px';
      document.documentElement.style.setProperty('--theme-header-height', height);
      if (getComputedStyle(section).position === 'sticky') document.documentElement.style.setProperty('--theme-sticky-header-height', height);
    }
  };
  const scheduleHeader = () => { if (!scrollFrame) scrollFrame = requestAnimationFrame(syncHeader); };
  window.addEventListener('scroll', scheduleHeader, { passive: true });
  window.addEventListener('resize', () => { collapseDelta = null; scheduleHeader(); });
  document.addEventListener('shopify:section:load', scheduleHeader);
  syncHeader();
  syncSubmenu();
  const panelObserver = new ResizeObserver(syncSubmenu);
  const observePanels = () => {
    panelObserver.disconnect();
    document.querySelectorAll(`${desktop} .park-menu__panel`).forEach(panel => panelObserver.observe(panel));
  };
  observePanels();
  document.addEventListener('shopify:section:unload', event => {
    if (!event.target.querySelector('#pageheader')) return;
    panelObserver.disconnect(); cancelAnimationFrame(scrollFrame); scrollFrame = 0; collapseDelta = null;
  });
  document.addEventListener('shopify:section:load', event => {
    if (!event.target.querySelector('#pageheader')) return;
    collapseDelta = null; observePanels(); scheduleHeader(); syncSubmenu();
  });
  window.addEventListener('resize', syncSubmenu);

  // Feedback only: account links keep their native navigation and remain retryable.
  let pendingAccount = null;
  let accountTimer = 0;
  const resetAccount = () => {
    clearTimeout(accountTimer);
    accountTimer = 0;
    pendingAccount?.removeAttribute('aria-busy');
    pendingAccount = null;
  };
  document.addEventListener('shopify:section:unload', event => {
    if (pendingAccount && (event.target.querySelector('#pageheader') || event.target.contains(pendingAccount))) resetAccount();
  });
  const histories = new WeakMap();
  const screens = menu => Array.from(menu.querySelectorAll('[data-menu-screen]'));
  const showScreen = (menu, key) => {
    screens(menu).forEach(screen => { screen.hidden = screen.dataset.menuScreen !== key; });
    menu.querySelector('[data-menu-back]').hidden = key === 'root';
    menu.closest('.mobile-navigation-drawer').classList.toggle('park-menu-in-sublevel', key !== 'root');
    menu.closest('.mobile-navigation-drawer').scrollTop = 0;
    menu.querySelectorAll('[data-menu-open]').forEach(button => {
      button.setAttribute('aria-expanded', String(button.dataset.menuOpen === key));
    });
    const panel = menu.querySelector('[data-menu-screen]:not([hidden])');
    if (panel) document.dispatchEvent(new CustomEvent('park:menu-panel-open', { detail: { panel } }));
  };
  document.addEventListener('click', event => {
    const menu = event.target.closest('.park-mobile-menu');
    if (!menu) return;
    const account = event.target.closest('a.park-menu__account[href]');
    if (account && window.innerWidth < 1280 && document.body.classList.contains('reveal-mobile-nav') &&
        !event.defaultPrevented && event.button === 0 && !event.metaKey && !event.ctrlKey &&
        !event.shiftKey && !event.altKey && !account.hasAttribute('download') &&
        (!account.target || account.target === '_self')) {
      resetAccount();
      pendingAccount = account;
      account.setAttribute('aria-busy', 'true');
      accountTimer = setTimeout(resetAccount, 10000);
      return;
    }
    const forward = event.target.closest('[data-menu-open]');
    const back = event.target.closest('[data-menu-back]');
    if (!forward && !back) return;
    event.preventDefault();
    const history = histories.get(menu) || [];
    if (forward) {
      history.push({ key: forward.closest('[data-menu-screen]').dataset.menuScreen, trigger: forward });
      showScreen(menu, forward.dataset.menuOpen);
      menu.querySelector('[data-menu-back]').focus({ preventScroll: true });
    } else {
      const previous = history.pop();
      showScreen(menu, previous?.key || 'root');
      previous?.trigger.focus({ preventScroll: true });
    }
    histories.set(menu, history);
  });
  // Keep the outgoing drawer visible until the document is replaced.
  // Reset restored pages through the native API so inert state, focus trap and ARIA agree.
  const closeRestoredDrawer = () => {
    if (document.body.classList.contains('reveal-mobile-nav')) window.theme?.closeMobileNav?.();
  };
  window.addEventListener('pageshow', () => {
    resetAccount();
    closeRestoredDrawer();
    document.querySelectorAll('.park-mobile-menu').forEach(menu => {
      histories.set(menu, []);
      showScreen(menu, 'root');
    });
  });
  // The theme creates/recreates the drawer in the editor. Delegation works for each copy.
  new MutationObserver(() => {
    if (document.body.classList.contains('reveal-mobile-nav')) return;
    resetAccount();
    document.querySelectorAll('.park-mobile-menu').forEach(menu => {
      if (!histories.get(menu)?.length) return;
      histories.set(menu, []);
      showScreen(menu, 'root');
    });
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
})();

/* Optional bounded HTML prefetch. This module never prerenders or fetches directly. */
(() => {
  if (window.parkMenuPrefetchInstalled || !window.HTMLScriptElement?.supports?.('speculationrules')) return;
  window.parkMenuPrefetchInstalled = true;
  const selected = new Set();
  const panelSelections = new WeakMap();
  const constrainedConnection = () => {
    const connection = navigator.connection;
    return connection?.saveData || /^(slow-)?2g$/.test(connection?.effectiveType || '');
  };
  const eligibleURL = anchor => {
    if (anchor.hasAttribute('download') || (anchor.target && anchor.target !== '_self')) return null;
    const raw = anchor.getAttribute('href');
    if (!raw || raw.includes('#')) return null;
    let url;
    try { url = new URL(raw, document.baseURI); } catch { return null; }
    if (!/^https?:$/.test(url.protocol) || url.origin !== location.origin || url.username || url.password) return null;
    // Exact collection/page destinations only, never products, account, cart or app routes.
    if (!/^\/(collections|pages)\/[^/%\\]+\/?$/.test(url.pathname)) return null;
    const theme = window.Shopify?.theme;
    if (theme?.role === 'unpublished' && url.searchParams.get('preview_theme_id') !== String(theme.id)) return null;
    if (url.href === location.href) return null;
    return url.href; // Preserve the existing preview_theme_id, view and every query value.
  };
  document.addEventListener('park:menu-panel-open', event => {
    if (constrainedConnection() || selected.size >= 8) return;
    const panel = event.detail?.panel;
    if (!(panel instanceof Element) || !panel.isConnected ||
        !panel.matches('.park-menu--desktop [data-menu-children], .park-mobile-menu [data-menu-screen]') ||
        panel.closest('[hidden]') || !panel.getClientRects().length) return;
    const used = panelSelections.get(panel) || new Set();
    const urls = [];
    for (const anchor of panel.querySelectorAll('a[href]')) {
      if (used.size >= 4 || selected.size >= 8) break;
      if (anchor.closest('[hidden]') || !anchor.getClientRects().length) continue;
      const url = eligibleURL(anchor);
      if (!url || used.has(url)) continue;
      used.add(url);
      if (selected.has(url)) continue;
      selected.add(url);
      urls.push(url);
    }
    panelSelections.set(panel, used);
    if (!urls.length) return;
    const rules = document.createElement('script');
    rules.type = 'speculationrules';
    rules.textContent = JSON.stringify({ prefetch: [{ source: 'list', urls, eagerness: 'immediate' }] });
    document.head.appendChild(rules);
  });
})();

